// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/gerenciarMaplayer/actions';

// Components
import { Main } from '../components/ManageMaplayer/Main';

// DnD
import { flow } from 'lodash';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

function mapStateToProps(state) {
	return {
		mapLayers: state.mapLayers
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch)
	};
}

export default flow(DragDropContext(HTML5Backend), connect(mapStateToProps, mapDispatchToProps))(Main);



// WEBPACK FOOTER //
// ./src/containers/GerenciarMaplayersContainer.js